import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { IFullStatusOnut } from '@modules/clients/services/olt/models/onus.model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-status-info-onu',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './status-info-onu.component.html',
})
export class StatusInfoOnuComponent implements OnInit {
  public onuDetails!: IFullStatusOnut;
  constructor(
    public readonly dynamicDialogRef: DynamicDialogRef,
    public readonly dynamicDialogConfig: DynamicDialogConfig<{
      sn: string;
      onuDetails: IFullStatusOnut;
    } | null>,
  ) {}
  ngOnInit(): void {
    if (this.dynamicDialogConfig.data?.sn) {
      const sn = this.dynamicDialogConfig.data.sn;
      this.getFullInfoStatus(sn);
    }
  }

  async getFullInfoStatus(sn: string) {
    if (this.dynamicDialogConfig.data) {
      this.onuDetails = this.dynamicDialogConfig.data?.onuDetails;
    }
  }
}
